// extracted by mini-css-extract-plugin
export default {"paginaComum":"PaginaComum_paginaComum__mjtQm"};